import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useTranslation } from '../../contexts/TranslationContext';
import FileStartEndDate from '../cms/FileStartEndDate';
import { FileMetadata } from '../../api/types/cms';
import useApi from '../../api';
import { useSnackbar } from 'notistack';
import { useResponseHandler } from '../../utils/response';
import { useImmer } from 'use-immer';
import FileInfo from '../cms/FileInfo';

type FileDateChangeDialogProps = {
    file?: FileMetadata | null;
    onClose?: (forceReload: boolean) => void;
};

export default function FileDateChangeDialog({
    file,
    onClose = () => {},
}: FileDateChangeDialogProps) {
    const { cms } = useApi();
    const { translate } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const { handleResponse } = useResponseHandler();

    const [dates, setDates] = useImmer({ startDate: '', endDate: '' });

    const save = () => {
        if (file) {
            cms.editFile(file.id, dates).then(response => {
                handleResponse(response, () => {
                    enqueueSnackbar(translate('messages.saved'), {
                        variant: 'success',
                    });
                    onClose(true);
                });
            });
        }
    };

    return (
        <Dialog open={Boolean(file)} onClose={() => onClose(false)}>
            <DialogTitle variant="h5">
                {translate('pages.cms.files.dates')}
            </DialogTitle>
            <DialogContent>
                {file && <FileInfo file={file} />}
                <FileStartEndDate file={file} onChange={setDates} />
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={() => onClose(false)}>
                    {translate('form.general.cancel')}
                </Button>
                <Button variant="contained" onClick={save}>
                    {translate('form.general.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
